import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import H1 from 'shared/app/components/h1';
import HeaderCrateWithLogo from 'shared/app/components/header-crate-with-logo';
import { commonMessages } from 'shared/app/messages/common-words';
import { oauthAuthorizeStatusSelector } from '../../state/selectors';
import messages from './messages';

const AuthorizeHeader = () => {
  const { formatMessage } = useIntl();
  const oauthAuthorizeStatus = useSelector(oauthAuthorizeStatusSelector);
  const { data, loading } = oauthAuthorizeStatus || {};
  const { authorized, redirectUri } = data || {};

  return (
    <HeaderCrateWithLogo>
      <H1 className="text-bold" size="lg">
        {formatMessage(
          loading === true || (authorized === true && redirectUri)
            ? commonMessages.loadingWithEllipsis
            : messages.headerTitle
        )}
      </H1>
    </HeaderCrateWithLogo>
  );
};

export default AuthorizeHeader;
